import React from 'react';
import Modal from 'react-modal';
import './DeleteMeetingModal.css';
import CloseIcon from '../../components/svg/closeIcon';

const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '400px',
    padding: '30px',
    borderRadius: '25px',
  },
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.3)',
    zIndex: '20',
  },
};

Modal.setAppElement('#root');

function UnsavedChangesDialog( {onClose, onExit }) {
  return (
    <Modal
      isOpen={true}
      onRequestClose={onClose}
      style={customStyles}
      contentLabel="Delete Meeting Confirmation"
    >
      <div className="delete-meeting-modal">
        <h2>Unsaved Changes  <div onClick={onExit}><CloseIcon  /></div></h2>
        <p>Are you sure you want to exit? 
<br />All changes will be lost.</p>
        <div className="button-group">
          <button className="exit-button" onClick={onExit}>
            Exit
          </button>
          <button className="go-back-button" onClick={onClose}>
            Stay on Page
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default UnsavedChangesDialog; 